import { WalletType } from '~/shared';

import { Currency } from '../Currency';
import { StyledContainer } from './VehicleCardPrice.styled';

const VehicleCardPrice = ({ amount }: { amount: number }) => (
	<StyledContainer>
		<Currency type={WalletType.Cash} value={amount} />
	</StyledContainer>
);

export { VehicleCardPrice };
